import React from 'react';
import VideoEmbed from './VideoEmbed';

const VideoCard = ({ duration, title, description, embedUrl }) => (
    <article className="overflow-hidden rounded-[16px] border border-[#e8e6e3] bg-white shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1)]">
        <VideoEmbed embedUrl={embedUrl} title={title} />
        <div className="p-4 md:p-5">
            <p className="font-dashboard text-[10px] leading-4 uppercase tracking-[0.6px] text-[#839282]">
                {duration}
            </p>
            <h3 className="mt-1.5 text-[15px] leading-[22px] font-medium text-[#2d2d2d]">
                {title}
            </h3>
            <p className="mt-1.5 text-[13px] leading-5 text-[#6b6b6b]">
                {description}
            </p>
        </div>
    </article>
);

export default VideoCard;
